import React from 'react';
import BasicPageActionRow from './BasicPageActionRow';
import BasicPageNavigation from './BasicPageNavigation';

function BasicPageHeader({
  shareData,
  listingId,
  isFeaturedTier = false,
  isSpotlightTier = false,
  navigationLocked = false,
  showActionRow = true,
}) {
  return (
    <header id="PageHeader" className="space-y-2 overflow-hidden rounded-none border-0 text-black" style={{ backgroundColor: 'var(--card)' }}>
      {showActionRow ? (
        <BasicPageActionRow
          shareData={shareData}
          listingId={listingId}
          isFeaturedTier={isFeaturedTier}
          isSpotlightTier={isSpotlightTier}
          navigationLocked={navigationLocked}
        />
      ) : null}
      <BasicPageNavigation />
    </header>
  );
}

export default BasicPageHeader;
